export default function HeroSection() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center overflow-hidden"
      aria-label="Company introduction"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Abstract%20dark%20gradient%20texture%20with%20subtle%20geometric%20line%20patterns%2C%20deep%20charcoal%20and%20black%20tones%2C%20modern%20minimalist%20technology%20inspired%20background%2C%20smooth%20flowing%20dark%20surfaces%20with%20very%20subtle%20light%20highlights%2C%20clean%20sophisticated%20atmosphere%2C%20no%20text%20no%20people%2C%20digital%20abstract%20art%2C%20elegant%20and%20refined&width=1800&height=1100&seq=od-nexora-hero-bg&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-background-950/75" />

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row lg:items-end gap-12 lg:gap-20">
          <div className="flex-1">
            <div className="mb-6">
              <div className="flex items-center gap-3">
                <span className="w-8 h-px bg-background-50/40" />
                <span className="text-background-50/60 font-label text-sm tracking-widest uppercase">
                  Engineering Excellence
                </span>
              </div>
            </div>

            <h1 className="font-heading text-6xl md:text-7xl lg:text-8xl xl:text-9xl leading-none text-background-50">
              <span className="block font-bold tracking-tight">OD Nexora</span>
              <span className="block font-light tracking-wide mt-1">LLC</span>
            </h1>

            <div className="mt-10 lg:mt-12 w-16 h-px bg-background-50/30" />
          </div>

          <div className="flex-1 lg:pb-4">
            <p className="text-background-50/80 text-base md:text-lg leading-relaxed max-w-lg font-body font-light">
              A professional engineering team focused on designing and developing
              modern digital software solutions for the iOS platform and related
              technologies. We build scalable, maintainable, and high-performance
              systems with a strong focus on usability, stability, and long-term
              technical quality.
            </p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent" />
    </section>
  );
}